
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import CookieConsent from './CookieConsent';

export default function SiteLayout() {
  return (
    <div className="site-shell">
      <Header />

      <main className="site-main">
        <Outlet />
      </main>

      <Footer />
      <CookieConsent />
    </div>
  );
}
